import tImg1 from '../images/team/img-1.jpg'
import tImg2 from '../images/team/img-2.jpg'
import tImg3 from '../images/team/img-3.jpg'
import tImg4 from '../images/team/img-4.jpg'


const Teams = [
   {
      Id: '1',
      tImg: tImg1,
      name: 'Wade Warren',
      slug: 'Wade-Warren',
      title: 'Interior Designer',
   },
   {
      Id: '2',
      tImg: tImg2,
      name: 'Leslie Alexander',
      slug: 'Leslie-Alexander',
      title: 'Web Designer',
   },
   {
      Id: '3',
      tImg: tImg3,
      name: 'Kathryn Murphy',
      slug: 'Kathryn-Murphy',
      title: 'Interior Designer',
   },
   {
      Id: '4',
      tImg: tImg4,
      name: 'Jerome Bell',
      slug: 'Jerome-Bell',
      title: 'President of Sales',
   },
   {
      Id: '5',
      tImg: tImg2,
      name: 'Leslie Alexander',
      slug: 'Leslie-Alexander',
      title: 'Web Designer',
   }

]

export default Teams;